import * as React from 'react';

//import { V3OneKeyComponentComponent } from './code-split/v3-one-key-component-component';
import V3OneKeyComponentModule from './components/v3-one-key-component'

const V3OneKeyComponent: React.FC<any> = (props) => {
  return <V3OneKeyComponent />;
};

export default V3OneKeyComponentModule;
